import { DocumentTypeActions } from './actions';
import { DocumentTypeEffects } from './effects';
import * as DocumentTypesSelectors from './doc-admin.selector';
import * as DocumentTypesReducer from './doc-admin-reducer';

export { DocumentTypeActions, DocumentTypeEffects, DocumentTypesSelectors, DocumentTypesReducer };
